import { useMutation } from '@tanstack/react-query'
import { savePaymentOriginator } from '@/app/lib/api-client'

export const useSavePaymentOriginator = () => {
  return useMutation({ mutationFn: savePaymentOriginator })
}
